import { ColorPalette } from '@wordpress/components';

function ColorLabel(props) {
  const {
    label,
    color
  } = props;

  const paragraphStyle = {
    display: 'flex', 
    alignItems: 'center'
  };

  return (
    <p style={ paragraphStyle }>
      <strong>{ label }</strong>
      <span className="component-color-indicator" style={ { background: color } } ></span>
    </p>
  );
}

function ColorControl(props) {  
  const {
    label,
    value,
    colors,
    onChange
  } = props;

  return (
    <>
      <ColorLabel 
        label={ label }
        color={ value }
      />
      <ColorPalette 
        colors={ colors }
        value={ value }
        onChange={ color => onChange( color ) }
      /> 
    </>
  );
}

export default ColorControl;